import { Button, Form, Input, Select, notification } from "antd";
import { useState } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import countryCode from "../../../asset/data/countryCode.json";
import { API } from "../../../Config/API";
import { POST } from "../../../utils/apiCalls";
import "../style.scss";

function Signup(props: any) {
  const [values, setValues] = useState<any>({});
  const [intrest, setIntrest] = useState<any>([]);
  const [loading, setLoading] = useState(false);

  const signUp = async (values: any) => {
    try {
      setLoading(true);
      let body = {
        data: {
          first_name: values.first_name,
          last_name: values.last_name,
          full_name: values.first_name + " " + values.last_name,
          email: values.email,
          password: values.password,
          code: values.code,
          mobile: values.mobile,
          intrest: intrest,
        },
      };

      let url = API.CREATE_USER;
      const response: any = await POST(url, body);
      if (response?.data?.id) {
        notification.success({
          message: "Success",
          description:
            "Account created successfully! Please login to continue.",
          duration: 3, // notification will show for 3 seconds
        });

        // Navigate to login page after showing success message
        setTimeout(() => {
          props.setAuthType();
        }, 1000);
      } else {
        setLoading(false);
        // Show backend error message if available
        notification.error({
          message: "Error",
          description: response?.data?.message || "Something went wrong......!",
        });
      }
    } catch (error: any) {
      setLoading(false);
      // Try to show error message from backend if available
      notification.error({
        message: "Error",
        description:
          error?.response?.data?.message ||
          error?.message ||
          "Something went wrong......!",
      });
    }
  };

  const prefixSelector = (
    <Form.Item name="code" noStyle>
      <Select
        style={{ width: 100, borderRadius: 4 }}
        showSearch
        defaultValue={"+91"}
      >
        {countryCode?.map((item: any) => {
          return (
            <Select.Option key={item?.dial_code} value={item?.dial_code}>
              {item?.dial_code}
            </Select.Option>
          );
        })}
      </Select>
    </Form.Item>
  );

  return (
    <div className="LoginScreen_box">
      <div className="LoginScreen_txt1">Sign Up</div>
      <div className="LoginScreen_txt2" onClick={() => props.setAuthType()}>
        Already have an account?{" "}
        <span className="LoginScreen_txt4">Sign in</span>
      </div>
      <br />
      <Form
        onFinish={signUp}
        initialValues={{
          first_name: values.first_name,
          last_name: values.last_name,
          email: values.email,
          password: values.password,
          code: values.code,
          mobile: values.mobile,
        }}
      >
        <Row>
          <Col md="6" xs={6}>
            <div className="LoginScreen_txt3">First Name</div>
            <Form.Item
              name={"first_name"}
              rules={[{ required: true, message: "Required" }]}
            >
              <Input size="large" style={{ borderRadius: 4 }} />
            </Form.Item>
          </Col>
          <Col md="6" xs={6}>
            <div className="LoginScreen_txt3">Last Name</div>
            <Form.Item
              name={"last_name"}
              rules={[{ required: true, message: "Required" }]}
            >
              <Input size="large" style={{ borderRadius: 4 }} />
            </Form.Item>
          </Col>
          <div className="LoginScreen_txt3">Email Address</div>
          <Form.Item
            name={"email"}
            rules={[{ required: true, message: "Required" }]}
          >
            <Input size="large" style={{ borderRadius: 4 }} />
          </Form.Item>
          <div className="LoginScreen_txt3">Mobile Number</div>
          <Form.Item
            name="mobile"
            rules={[{ required: true, message: "Required" }]}
          >
            <Input
              addonBefore={prefixSelector}
              size="large"
              style={{ borderRadius: 4 }}
            />
          </Form.Item>
          <div className="LoginScreen_txt3">Password</div>
          <Form.Item
            name={"password"}
            rules={[{ required: true, message: "Required" }]}
          >
            <Input.Password size="large" style={{ borderRadius: 4 }} />
          </Form.Item>
          <br />
          <Form.Item>
            <Button
              style={{
                backgroundColor: "#b72c6f",
                height: 50,
                color: "#fff",
                borderRadius: 4,
              }}
              size="large"
              block
              htmlType="submit"
              loading={loading}
            >
              Continue
            </Button>
          </Form.Item>
        </Row>
      </Form>
    </div>
  );
}

export default Signup;
